import patientdashboardimg from '../../media/image.jpg';
import { useNavigate } from 'react-router-dom';
import './AdminSidebar.css';
import './Sidebar.css'
import '../../App.css';
import { useEffect, useState } from 'react';
import { useStateValue } from "../../Component/StateProviders";
export default function AdminSidebar() {

  const [{ Loading }, dispatch] = useStateValue();

  let navigate = useNavigate();
  const [DocData, setDocData] = useState({});
  useEffect(() => {

    var Url = window.API_PREFIX + 'admin/doctordetail'
    fetch(Url, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
      },
      body: JSON.stringify(
        {
          Token: localStorage.getItem('DToken'),


        }
      ),
    }).then(resp => resp.json()).then(data => {
      console.log(data)
      if (data['status'] === "1") {

        setDocData({ ...data['data'] })

      }
    })



  }, [])


  return (
    <div className='sidebar_main_division'>

      <div className={window.location.pathname.includes('/administration/dashboard') ? 'sidebar_dashboard_title_division_active' : "sidebar_dashboard_title_division"}
        onClick={() => {

          navigate('/administration/dashboard')
        }}
      ><i class="fa-solid fa-shapes me-2"></i> Dashboard</div>

      <div className={window.location.pathname.includes('/administration/mitwankappointmentbydate') ? 'sidebar_dashboard_title_division_active' : "sidebar_dashboard_title_division"}
        onClick={() => {

          navigate('/administration/mitwankappointmentbydate')
        }}
      ><i class="fa-solid fa-calendar-days me-2"></i> Appointment By Date</div>

      <div className={window.location.pathname.includes('/administration/my-clients') ? 'sidebar_dashboard_title_division_active' : 'sidebar_dashboard_title_division'}
        onClick={() => {

          navigate('/administration/my-clients')

        }}
      ><i class="fa-solid fa-user me-2"></i> My Clients</div>
      <div className={window.location.pathname.includes('/administration/schedule-timing') ? 'sidebar_dashboard_title_division_active' : 'sidebar_dashboard_title_division'}
        onClick={() => {
          navigate('/administration/schedule-timing')

        }}
      ><i class="fa-solid fa-calendar-day me-2"></i>Schedule Timing</div>

      <div className={window.location.pathname.includes('/administration/packages') ? 'sidebar_dashboard_title_division_active' : 'sidebar_dashboard_title_division'}
        onClick={() => {
          navigate('/administration/packages')
        }}
      ><i class="fa-solid fa-box-open me-2"></i> Packages</div>

      <div className={window.location.pathname.includes('/administration/mitwankchangepassword') ? 'sidebar_dashboard_title_division_active' : 'sidebar_dashboard_title_division'}
        onClick={() => {
          navigate('/administration/mitwankchangepassword')

        }}
      ><i class="fa-solid fa-key me-2"></i> Change Password </div>
      <div className={window.location.pathname.includes('/administration/clientmessages') ? 'sidebar_dashboard_title_division_active' : 'sidebar_dashboard_title_division'}
        onClick={() => {
          navigate('/administration/clientmessages')

        }}
      ><i class="fa-solid fa-message me-2"></i> Messages</div>

      <div className={window.location.pathname.includes('/administration/newsletter') ? 'sidebar_dashboard_title_division_active' : 'sidebar_dashboard_title_division'}
        onClick={() => {
          navigate('/administration/newsletter')

        }}
      ><i class="fa-solid fa-envelope me-2"></i> Newsletter</div>

      <div className={window.location.pathname.includes('/administration/trash') ? 'sidebar_dashboard_title_division_active' : 'sidebar_dashboard_title_division'}
        onClick={() => {
          navigate('/administration/trash')

        }}
      ><i class="fa-solid fa-trash me-2"></i> Trash</div>

      <div className={window.location.pathname.includes('/administration/delete-request') ? 'sidebar_dashboard_title_division_active' : 'sidebar_dashboard_title_division'}
        onClick={() => {
          navigate('/administration/delete-request')

        }}
      ><i class="fa-solid fa-trash me-2"></i> Delete Request</div>

      <div className='sidebar_dashboard_title_division'
        onClick={() => {
          localStorage.clear()
          navigate('/')

        }}
      ><i class="fa-solid fa-right-from-bracket me-2"></i> Logout </div>

    </div>
  )
}